const getFormFields = formSchema =>
  Object.keys(formSchema.properties).map(fieldKey => formSchema.properties[fieldKey]);

export { getFormFields };
